const path = {
  Home: '/',
  RequestInvoice: '/request-invoice',
};

export default path;
